/**
 * This file will export an object containing the project route path
 */
const ROUTE_APP_PATHS = Object.freeze({
  root: "/",
  spaces: "/spaces",
  survey: "/surveys",
  auth: "/auth",
});

export default ROUTE_APP_PATHS;
